import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_NOTETYPES_LOAD,
    ACTION_NOTETYPES_LOAD_BY_ID,

    ACTION_NOTETYPES_SAVE,

    ACTION_NOTETYPES_CREATE,

    ACTION_NOTETYPES_VALIDATE,

    INoteTypeLoadAction,
    INoteTypeLoadByIdAction,
    INoteTypeLoadFailureAction,
    INoteTypeLoadSuccessAction,

    INoteTypeSaveAction,
    INoteTypeSaveSuccessAction,
    INoteTypeSaveFailureAction,

    INoteTypeCreateAction,
    INoteTypeCreateSuccessAction,
    INoteTypeCreateFailureAction,

    INoteTypeValidateAction,
    INoteTypeValidateSuccessAction,
    INoteTypeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/noteType";
import { noteTypesApi } from "../services/noteTypes";


export const
    getNoteTypesEpic = (action$): Observable<INoteTypeLoadSuccessAction | INoteTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_NOTETYPES_LOAD)
            .mergeMap((_action: INoteTypeLoadAction) => {
                return noteTypesApi
                    .getNoteTypes()
                    .map(response =>
                        LoadSuccess(response.noteTypes, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getNoteTypeByIdEpic = (action$): Observable<INoteTypeLoadSuccessAction | INoteTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_NOTETYPES_LOAD_BY_ID)
            .mergeMap((action: INoteTypeLoadByIdAction) => {
                return noteTypesApi
                    .getNoteTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.noteType, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setNoteTypeEpic = (action$): Observable<INoteTypeSaveSuccessAction | INoteTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_NOTETYPES_SAVE)
            .mergeMap((action: INoteTypeSaveAction) => {
                return noteTypesApi
                    .setNoteType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.noteType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createNoteTypeEpic = (action$): Observable<INoteTypeCreateSuccessAction | INoteTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_NOTETYPES_CREATE)
            .mergeMap((_action: INoteTypeCreateAction) => {
                return noteTypesApi
                    .createNoteType()
                    .map(response =>
                        CreateSuccess(
                            response.noteType,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateNoteTypeEpic = (action$): Observable<INoteTypeValidateSuccessAction | INoteTypeValidateFailureAction> => {
        return action$
            .ofType(ACTION_NOTETYPES_VALIDATE)
            .mergeMap((action: INoteTypeValidateAction) => {
                return noteTypesApi
                    .validateNoteType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.noteType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



